import { ServiceNameEnum } from '../../../../types';
import { DashboardPeriod } from '../../../../types/dashboard';

export enum ScamWidgetId {
  SummaryScam = 'summaryScam',
  SummaryScamPrevious = 'summaryScamPrevious',
  ScamTopEmailSender = 'scamTopEmailSender',
  ScamTopRecipient = 'scamTopRecipient',
  ScamByFilter = 'scamFilter',
}

type Service =
  | ServiceNameEnum.Box
  | ServiceNameEnum.Dropbox
  | ServiceNameEnum.GoogleDrive
  | ServiceNameEnum.SalesforceProduction
  | ServiceNameEnum.SalesforceSandbox
  | ServiceNameEnum.Exchange
  | ServiceNameEnum.SharePoint
  | ServiceNameEnum.OneDrive
  | ServiceNameEnum.Teams
  | ServiceNameEnum.TeamsChat
  | ServiceNameEnum.Gmail
  | ServiceNameEnum.GmailInline;

type ScamSummaryData = Record<
  DashboardPeriod,
  { [key in Service]?: { total?: number } }
>;

type ScamTop5Data = Record<
  DashboardPeriod,
  {
    key: string;
    total: number;
    last_detected: string;
    aliases: string[];
  }[]
>;

type ScamByFilterData = Record<
  DashboardPeriod,
  {
    key: string;
    total: number;
    last_detected: string;
  }[]
>;

export interface ScamData {
  [ScamWidgetId.SummaryScam]: ScamSummaryData;
  [ScamWidgetId.SummaryScamPrevious]: ScamSummaryData;
  [ScamWidgetId.ScamTopEmailSender]: ScamTop5Data;
  [ScamWidgetId.ScamTopRecipient]: ScamTop5Data;
  [ScamWidgetId.ScamByFilter]: ScamByFilterData;
}
